import { render, staticRenderFns } from "./sixecg.vue?vue&type=template&id=c2a759be&scoped=true&"
import script from "./sixecg.vue?vue&type=script&lang=js&"
export * from "./sixecg.vue?vue&type=script&lang=js&"
import style0 from "./sixecg.vue?vue&type=style&index=0&id=c2a759be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a759be",
  null
  
)

export default component.exports